module.exports = __webpack_public_path__ + "static/media/hema.b5665cf8.jpeg";